import { useTranslation } from 'react-i18next';
import type { VendorCustomerType } from '@econtractor/types';
import { isCustomerPersonType } from 'modules/objects';
import VendorCustomerAction from '../VendorCustomerAction';

interface VendorCustomersTableRowProps {
    row: VendorCustomerType;
    onEdit: (row: VendorCustomerType) => void;
    onDelete: (row: VendorCustomerType) => void;
}

const VendorCustomersTableRow = ({ row, onEdit, onDelete }: VendorCustomersTableRowProps) => {
    const { t } = useTranslation(['Objects']);

    const personType = row.customer?.personType;
    const personTypeLabel = isCustomerPersonType(personType)
        ? t(`customer.personTypes.${personType}`)
        : personType || '-';

    return (
        <tr className="cursor-pointer" onClick={() => onEdit(row)}>
            <td className="name text-break">{row.fullName || '-'}</td>
            <td className="article text-break">{row.edrpouOrIpn || '-'}</td>
            <td className="status">{personTypeLabel}</td>
            <td className="action" onClick={(e) => e.stopPropagation()}>
                <VendorCustomerAction row={row} onEdit={onEdit} onDelete={onDelete} />
            </td>
        </tr>
    );
};

export default VendorCustomersTableRow;
